class I18N {
  constructor() {
    this.locale = 'en';
    this.texts = require(`../../locales/${this.locale}.json`);
    this.availableLanguages = ['en', 'it'];

    this.setLocale = this.setLocale.bind(this);
    this.getTexts = this.getTexts.bind(this);
  }
  setLocale(locale) {
    // keep only language definition
    locale = locale.replace(/-[A-Z]{2}$/, '');

    // fallback to english
    if (!~this.availableLanguages.indexOf(locale)) {
      locale = 'en';
    }

    this.locale = locale;
    this.texts = require(`../../locales/${locale}.json`);

    console.log(`[i18n] Current locale: ${locale}`);
  }
  getTexts() {
    return this.texts;
  }

  translate(path) {
    let textObj = this.texts;
    const spath = path.split('.');
    for (let i = 0, len = spath.length; i < len; i++) {
      if (!textObj || typeof textObj !== 'object') {
        return `[i18n] path not found "${path}"`;
      }
      textObj = textObj[spath[i]];
    }
    return textObj;
  }
}

export default new I18N();



/** WEBPACK FOOTER **
 ** ./web/js/libs/i18n.js
 **/